/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSouscriptionWaiverStagesMutation($input: SaveSouscriptionWaiverStages_M_souscription_waiver_stagesInput!) {
    saveSouscriptionWaiverStages_M_souscription_waiver_stages(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
